var exports = {
  "zr": "ThemeModeSwitch.module__root___Yld6dW",
  "oE": "ThemeModeSwitch.module__compact___Yld6dW",
  "Pf": "ThemeModeSwitch.module__label___Yld6dW",
  "Xg": "ThemeModeSwitch.module__segmented___Yld6dW",
  "uK": "ThemeModeSwitch.module__option___Yld6dW",
  "J_": "ThemeModeSwitch.module__optionOn___Yld6dW",
};

module.exports = exports;
